import { Mesa } from "./mesa";
import { PedidoDetalle } from "./pedido_detalle";

export class Pedido{
    public constructor(
        public id: String = "",
        //public precio: number = 0,
        public subtotal_iva12:number = 0,
        public subtotal_iva0:number = 0,
        public desct_valor:number = 0,
        public desct_porcent:number = 0,
        public subt_desct_iva12:number = 0,
        public subt_desct_iva0:number = 0,
        public iva:number = 0,
        public total: number = 0,
        public observacion: String = "",
        public fecha_pedido: String = "",
        public is_entregado: boolean = false,
        public is_facturado: boolean = false,
        public mesa_id: String = "",
        public empresa_id: String = "",
        public impuesto_iva_id: String = "",
        public usuario_id: String = null,
        // public mesa:Mesa = new Mesa(), 
        public detalle: Array<PedidoDetalle> = [],
        public detalleEliminado: Array<PedidoDetalle> = [],
        public detalle_id: String = "",
        public status: String = "",
        public fecha_ingreso: String = "",
        public diffTime: String = "",
        public loading: boolean = false,
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/pedido.ts